import axios from 'axios';
import {SERVER_API_URL} from '@/constants';
import {authService} from '@/auth/AuthServiceInst'

const TIMEOUT = 1000000;

const onRequestSuccess = async config => {
    config.timeout = TIMEOUT;
    config.url = `${SERVER_API_URL}${config.url}`;
    const token = await authService.acquireToken();
    config.headers.common['Authorization'] = `Bearer ${token}`;
    return config;
};

const setupAxiosInterceptors = onUnauthenticated => {

    const onResponseSuccess = response => response;
    const onResponseError = err => {
        const status = err.status || (err.response && err.response.status);
        if (status === 500 && err.response.data.message === 'Expired JWT') {
            authService.logout();
        }
        if (status === 403 || status === 401) {
            onUnauthenticated();
        }
        return Promise.reject(err);
    };
    if (axios.interceptors) {
        axios.interceptors.request.use(onRequestSuccess);
        axios.interceptors.response.use(onResponseSuccess, onResponseError);
    }
};


export { onRequestSuccess, setupAxiosInterceptors };
